import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import vAdminformat from '../../adminFormat';
import CustomDateRangePicker from "../CustomDateRangePicker";
import JobLiveUpdate from "./JobLiveUpdate";
import ScanPointDesk from "./ScanPointDesk";
import JobPrintFolderView from "./JobPrintFolderView";
import AddLiveJobComment from "./AddLiveJobComment";
import Swal from "sweetalert2";
import validateError from "../../ValidateError";
import SimpleSTLViewer from '../Canvas/SimpleStlViewerGridOrder';
import Selecto from "react-selecto";
import getFileExtension from "../getFileExtension";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";
import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";

const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const WaxMouldFolder = ({ email, isRepriting }) => {
    const [JobList, setJobList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("fullname");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [viewBJob, setViewBJob] = useState(false);
    const [currentJob, setCurrentJob] = useState('');
    const [currentOrder, setCurrentOrder] = useState(0);
    const [collectiveList, setcollectiveList] = useState([]);
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null,
    });
    const [isGridView, setIsGridView] = useState(false);
    const [selectedJobs, setSelectedJobs] = useState([]);
    const [addCollectiveModal, setAddCollectiveModal] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(0);
    const [filterByJob, setFilterByJob] = useState("fullname");
    const [filterStatusJob, setFilterStatusJob] = useState(0);
    const [filterValueJob, setFilterValueJob] = useState(null);
    const [gridjobList, setGridJobList] = useState([]);
    const [filtersEnabledJob, setFiltersEnabledJob] = useState(false);

    const [isPointScan, setIsPointScan] = useState(false);
    const [isComment, setIsComment] = useState(false);
    const [cardSize, setCardSize] = useState("vs");
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [imageURL, setImageURL] = useState("");
    const [temporalJobSelected, setTemporalJobSelected] = useState([]);
    const [currentJobToPrint, setCurrentJobToPrint] = useState([]);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);


    const [statusQuot, setStatusQuot] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    useEffect(() => {
        setJobList([]);
        const getJobs = async () => {
            try {
                const response = await axios.get(`${server_backend}/Jobs/manual/search_print?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);

                const data = response.data.RES_RESULT || [];

                const filtered = data.filter(item =>
                    (item.est_ID === 18) &&
                    item.isMould === 1
                );

                const finalList = filtered.filter(item =>
                    isRepriting ? item.reprint > 1 : item.reprint <= 1
                );

                setJobList(finalList);



            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };

        getJobs();
    }, [isRepriting]);

    const getJobs = async () => {

        try {
            const response = await axios.get(`${server_backend}/Jobs/manual/search_print?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            //console.log("Unexpected error, please check")

            const data = response.data.RES_RESULT || [];

            const filtered = data.filter(item =>
                (item.est_ID === 18) &&
                item.isMould === 1
            );

            const finalList = filtered.filter(item =>
                isRepriting ? item.reprint > 1 : item.reprint <= 1
            );

            setJobList(finalList);

        } catch (error) {
            console.log("Unexpected error, please check")
        }

    }

    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                if (response.data.RES_CODE === "00") {
                    //console.log("Unexpected error, please check")






                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getStatusJob();
    }, []);

    useEffect(() => {
        const geCollectiveGroup = async () => {
            try {
                const response = await axios.get(`${server_backend}/collective/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setcollectiveList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        geCollectiveGroup();
    }, []);

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
        /*   if (filtersEnabled) {
              FilterCustomer();
          } */
    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {

        try {
            const response = await axios.get(`${server_backend}/Jobs/manual/search_print?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            const data = response.data.RES_RESULT || [];

            const filtered = data.filter(item =>
                (item.est_ID === 18) &&
                item.isMould === 1
            );

            const finalList = filtered.filter(item =>
                isRepriting ? item.reprint > 1 : item.reprint <= 1
            );

            setJobList(finalList);

        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);

    const showViewJob = () => {
        setViewBJob(true);
    }

    const CloseViewJob = () => {
        setViewBJob(false);
    }


    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const CloseModalScanPoint = () => {
        setIsPointScan(false);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = JobList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(JobList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDateChange = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };

    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showAddCommentModal = () => {
        setIsComment(true)
    }


    //Here to grid Jobs




    useEffect(() => {
        if (filtersEnabledJob) {
            FilterGridJobs();
        }
    }, [filterByJob, filterStatusJob, filterValueJob, selectedDayRange]);

    const AsignCollectiveGroup = async (JobID, GroupID) => {
        try {
            const response = await axios.post(`${server_backend}/jobs/manual/update_collective`, {
                id: JobID,
                collective: GroupID
            }, headers);
            //console.log("Unexpected error, please check")






            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Update Successfully',
                    showConfirmButton: false,
                    timer: 1000
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'An error occurred, please try again.',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            console.log("Unexpected error, please check")
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            getJobs();
        }

    }

    const AsignGridCollectiveGroup = async (JobID, GroupID) => {
        try {
            const response = await axios.post(`${server_backend}/jobs/manual/update_collective`, {
                id: JobID,
                collective: GroupID
            }, headers);

        } catch (error) {
            return error
        }

    }

    const handleGroupChange = (e) => {
        setSelectedGroup(e.target.value);
    }

    const handleDateChangeJob = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };

    const handleFilterValueChangeJob = (e) => {
        setFilterValueJob(e.target.value);

        /*   if (filtersEnabledJob) {
              FilterGridJobs();
          } */
    };

    const toggleView = () => {
        setIsGridView(!isGridView);
    };

    useEffect(() => {

        const getGridJobs = async () => {
            try {
                const response = await axios.get(`${server_backend}/Jobs/manual/list`, headers);
                if (response.data.RES_CODE === "00") {
                    //This will filter only jobs in production exept complete ones
                    const filterJobs = response.data.RES_RESULT.filter((job) => {
                        return job.status_order !== 7 && job.colle_id === 0 && job.isMould === 1 && job.est_ID === 18;
                    }
                    );
                    setGridJobList(filterJobs);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }

        setTimeout(() => {
            getGridJobs();
        }, 500);

    }, [isGridView]);

    const getGridJobs = async () => {
        try {
            const response = await axios.get(`${server_backend}/Jobs/manual/list`, headers);
            if (response.data.RES_CODE === "00") {
                //This will filter only jobs in production exept complete ones
                const filterJobs = response.data.RES_RESULT.filter((job) => {
                    return job.status_order !== 7 && job.colle_id === 0 && job.isMould === 1 && job.est_ID === 18;
                }
                );
                const finalList = filterJobs.filter(item =>
                    isRepriting ? item.reprint > 1 : item.reprint <= 1
                );
                setGridJobList(finalList);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const handleFiltersToggleJob = () => {
        setFiltersEnabledJob(!filtersEnabled);
    };

    useEffect(() => {
        if (!isGridView) {
            setFiltersEnabledJob(false);
        } else {
            setFiltersEnabled(false);
        }
    }, [isGridView]);

    const handleCheckboxChange = (object) => {
        const id = String(object.job_ID);

        setTemporalJobSelected(prev => {
            const exists = prev.some(item => item.job_ID === object.job_ID);
            if (exists) {
                return prev.filter(item => item.job_ID !== object.job_ID);
            } else {
                return [...prev, object];
            }
        });

        setSelectedJobs(prev => {
            if (prev.includes(id)) {
                return prev.filter(i => i !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    const handleDeselect = (e) => {
        const deselectedElements = e.deselected || [];
        const deselectedIDs = deselectedElements.map(el => el.getAttribute("data-job-id"));

        setSelectedJobs(prev => prev.filter(id => !deselectedIDs.includes(id)));
    };

    const addJobToGroup = async () => {

        try {
            for (let group of selectedJobs) {
                await AsignGridCollectiveGroup(group, selectedGroup);
            }
            Swal.fire({
                icon: 'success',
                title: 'Added Successfully',
                showConfirmButton: false,
                timer: 1000
            });
            getGridJobs();
            setSelectedJobs([]);
            closeModalCollective();

        } catch (error) {
            console.log("Unexpected error, please check")
        }

    }

    const openModalCollective = () => {
        setAddCollectiveModal(true);
    }

    const closeModalCollective = () => {
        setAddCollectiveModal(false);
    }

    const handleFilterByChangeJob = (e) => {
        setFilterByJob(e.target.value);
        const value = e.target.value;

    };

    useEffect(() => {
        if (filtersEnabledJob) {
            FilterGridJobs();
        }
    }, [filterByJob, filterStatusJob, filterValueJob, selectedDayRange]);

    const FilterGridJobs = async () => {

        try {
            const response = await axios.get(`${server_backend}/Jobs/search?user_transaction=${email}&findby=${filterByJob}&findfor=${filterValueJob}&est_id=${filterStatusJob}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);

            const filterJobs = response.data.RES_RESULT.filter((job) => {
                return job.status_order !== 7 && job.colle_id === 0;
            })
            setGridJobList(filterJobs);

        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    const selectoRef = useRef();

    useEffect(() => {
        const container = document.querySelector(".col-lg-12");
        const onScroll = () => {
            if (selectoRef.current) {
                selectoRef.current.checkScroll();
            }
        };

        if (container) {
            container.addEventListener("scroll", onScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", onScroll);
            }
        };
    }, []);


    // Print functionality




    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Label Information ${vAdminformat.FormatDateTime(new Date())}`,
        onAfterPrint: () => setShowPrintableDiv(false),

    });

    const printSingleSelected = async (JobSelected) => {
        if (JobSelected.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No jobs selected',
                text: 'Please select at least one job to print.',
                confirmButtonText: 'OK'
            });
            return;
        }

        setLoading(true);
        setProgress(0);
        setShowPrintableDiv(true);

        const totalJobs = JobSelected.length;
        let images = [];

        for (let i = 0; i < totalJobs; i++) {
            const job = JobSelected[i];
            let imageUrl;

            if (job.isMould === 1) {

                const fileExtension = getFileExtension(job.files_path_file);

                if (fileExtension === "stl" || fileExtension === "obj") {

                    imageUrl = await SimpleSTLViewerToImage(`${server_backend}/${job.files_path_file}`);
                }
                else {

                    imageUrl = `${server_backend}/${job.files_path_file}`;
                }
            } else {
                imageUrl = await SimpleSTLViewerToImage(`${server_backend}/${job.files_path_file}`);
            }

            images.push(imageUrl);
            setProgress(Math.round(((i + 1) / totalJobs) * 100));
        }

        const jobsWithImages = JobSelected.map((job, i) => ({
            ...job,
            image: images[i]
        }));

        setCurrentJobToPrint(jobsWithImages);

        setTimeout(() => {
            setLoading(false);
            setProgress(0);
            handlePrint();
        }, 500);
        setTimeout(async () => {
            const result = await Swal.fire({
                icon: 'question',
                title: 'Mark jobs as printed?',
                text: 'Would you like to mark all selected jobs as "Printed" in the system?',
                showCancelButton: true,
                confirmButtonText: 'Yes, mark as Printed',
                cancelButtonText: 'No, leave unchanged'
            });

            if (result.isConfirmed) {
                let allSuccess = true;

                for (let Job of JobSelected) {
                    try {
                        await axios.post(`${server_backend}/Jobs/manual/tracking/insert`, {
                            title: "PRINT",
                            comment: '',
                            qty: 0,
                            reference: 0,
                            id: Job.job_ID,
                        }, headers);
                    } catch (error) {
                        allSuccess = false;
                        Swal.fire({
                            icon: 'error',
                            title: 'Update failed',
                            text: 'An error occurred while updating one or more job statuses.',
                            confirmButtonText: 'OK'
                        });
                        break;
                    }
                }

                if (allSuccess) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Jobs marked as Printed',
                        text: 'All selected jobs were successfully updated.',
                        confirmButtonText: 'OK'
                    });
                }
                getGridJobs();
            }
        }, 1000);

    };


    const printGroupSelected = async () => {
        if (temporalJobSelected.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No jobs selected',
                text: 'Please select at least one job to print.',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Step 1: Ask if user wants to add jobs to a group
        const groupChoice = await Swal.fire({
            icon: 'question',
            title: 'Add to a group before printing?',
            text: 'Would you like to assign the selected jobs to a group or proceed individually?',
            showCancelButton: true,
            confirmButtonText: 'Yes, add to group',
            cancelButtonText: 'No, proceed individually'
        });

        let groupId = null;

        if (groupChoice.isConfirmed) {
            // Step 2: Show generic select for group choice
            const { value: selectedGroup } = await Swal.fire({
                title: 'Select a group',
                html: `
                <select id="swal-select-group" class="swal2-select" style="width:80%;font-size:13px;">
                    <option value="" disabled selected>-- Choose a group --</option>
                    ${collectiveList.map(group => `
                        <option value="${group.colle_id}">${group.name}</option>
                    `).join('')}
                </select>
            `,
                preConfirm: () => {
                    const value = document.getElementById('swal-select-group').value;
                    if (!value) {
                        Swal.showValidationMessage('You need to select or create a group');
                    }
                    return value;
                },
                confirmButtonText: 'Confirm'
            });

            groupId = selectedGroup; // ← attach group later
        }

        // Step 3: Continue with print logic
        setLoading(true);
        setProgress(0);
        setShowPrintableDiv(true);

        const totalJobs = temporalJobSelected.length;
        let images = [];

        for (let i = 0; i < totalJobs; i++) {
            const job = temporalJobSelected[i];
            let imageUrl;

            if (job.isMould === 1) {
                const fileExtension = getFileExtension(job.files_path_file);
                if (fileExtension === "stl" || fileExtension === "obj") {
                    imageUrl = await SimpleSTLViewerToImage(`${server_backend}/${job.files_path_file}`);
                } else {
                    imageUrl = `${server_backend}/${job.files_path_file}`;
                }
            } else {
                imageUrl = await SimpleSTLViewerToImage(`${server_backend}/${job.files_path_file}`);
            }

            images.push(imageUrl);
            setProgress(Math.round(((i + 1) / totalJobs) * 100));
        }

        const jobsWithImages = temporalJobSelected.map((job, i) => ({
            ...job,
            image: images[i],
            colle_id: groupId || null
        }));

        setCurrentJobToPrint(jobsWithImages);

        setTimeout(() => {
            setLoading(false);
            setProgress(0);
            handlePrint();
        }, 500);

        // Step 4: After printing, confirm if jobs should be marked as Printed
        setTimeout(async () => {
            const result = await Swal.fire({
                icon: 'question',
                title: 'Confirm successful printing',
                text: 'Did the printing process complete successfully? If yes, the jobs will be marked as "Printed" and assigned to the selected group.',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No, something went wrong'
            });

            if (result.isConfirmed) {
                let allSuccess = true;

                for (let Job of temporalJobSelected) {
                    try {
                        await axios.post(`${server_backend}/Jobs/manual/tracking/insert`, {
                            title: "PRINT",
                            comment: '',
                            qty: 0,
                            reference: 0,
                            id: Job.job_ID,
                        }, headers);
                    } catch (error) {
                        allSuccess = false;
                        Swal.fire({
                            icon: 'error',
                            title: 'Update failed',
                            text: 'An error occurred while updating one or more job statuses.',
                            confirmButtonText: 'OK'
                        });
                        break;
                    }
                }

                if (allSuccess) {
                    if (groupId) {
                        for (let job of temporalJobSelected) {
                            await AsignGridCollectiveGroup(job.job_ID, groupId);
                        }
                    }

                    Swal.fire({
                        icon: 'success',
                        title: 'Jobs marked as Printed',
                        text: 'All selected jobs were successfully confirmed and updated.',
                        confirmButtonText: 'OK'
                    });
                }
                getGridJobs();
            }
        }, 1000);
    };



    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "hidden" }}>
            {viewBJob ? (

                <JobPrintFolderView JobID={currentJob} getJobs={getJobs} CloseViewJob={CloseViewJob} />
            ) : (
                isUpdating ? (
                    <JobLiveUpdate JobID={currentJob} getJobs={getJobs} CloseViewJob={CloseModalUpdate} />
                ) : (

                    isPointScan ? (
                        <ScanPointDesk OrderID={currentOrder} getJobs={getJobs} CloseModalScanPoint={CloseModalScanPoint} />
                    ) : (

                        <div>
                            {loading && (
                                <div style={{
                                    position: 'fixed',
                                    top: 0, left: 0,
                                    width: '100vw', height: '100vh',
                                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                    zIndex: 9999,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: '#fff',
                                    fontSize: '18px'
                                }}>
                                    <div className="spinner-border text-light" role="status" />
                                    <p className="mt-3">Generating labels... {progress}%</p>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">{isRepriting ? "Wax Folders" : "Wax Folders"}</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Jobs</a></li>
                                                <li className="breadcrumb-item active">List</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card p-2" id="tasksList" style={{ minHeight: "85vh" }}>
                                        <div className="card-header bJob-0">
                                            <div className="d-flex flex-wrap align-items-center gap-3">
                                                <h5 className="card-title mb-0 flex-grow-1">All Jobs</h5>
                                                {isGridView && selectedJobs.length > 0 && (
                                                    <div className="d-flex align-items-center">
                                                        <span className="badge bg-primary-subtle text-primary fs-6 d-flex align-items-center px-3 py-2">
                                                            <i className="ri-checkbox-multiple-line me-2"></i>
                                                            {selectedJobs.length} Selected
                                                        </span>
                                                    </div>
                                                )}
                                                {isGridView && selectedJobs.length > 0 && (
                                                    <div>
                                                        <button
                                                            className="btn btn-outline-warning d-flex align-items-center"
                                                            type="button"
                                                            id="sendToPrintedDropdown"
                                                            onClick={printGroupSelected}
                                                        >
                                                            <i className="ri-upload-2-line me-2"></i> Send To Printed
                                                        </button>
                                                    </div>
                                                )}



                                                {isGridView && selectedJobs.length > 0 && (
                                                    <button type="button" className="btn btn-success d-flex align-items-center" onClick={openModalCollective}>
                                                        <i className="ri-add-line me-1 align-bottom"></i> Add to group
                                                    </button>
                                                )}

                                                {isGridView && (
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn btn-outline-primary dropdown-toggle d-flex align-items-center"
                                                            type="button"
                                                            id="cardSizeDropdown"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="ri-layout-grid-line me-2"></i> Card Size
                                                        </button>
                                                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="cardSizeDropdown">
                                                            <li>
                                                                <button className={`dropdown-item ${cardSize === "vs" ? "active" : ""}`} onClick={() => setCardSize("vs")}>Very Small</button>
                                                            </li>
                                                            <li>
                                                                <button className={`dropdown-item ${cardSize === "sm" ? "active" : ""}`} onClick={() => setCardSize("sm")}>Small</button>
                                                            </li>
                                                            <li>
                                                                <button className={`dropdown-item ${cardSize === "md" ? "active" : ""}`} onClick={() => setCardSize("md")}>Medium</button>
                                                            </li>
                                                            <li>
                                                                <button className={`dropdown-item ${cardSize === "lg" ? "active" : ""}`} onClick={() => setCardSize("lg")}>Large</button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                )}

                                                {!isRepriting && (
                                                    <button className="btn btn-outline-secondary border-0 d-flex align-items-center" onClick={toggleView}>
                                                        <i className={isGridView ? "ri-list-check-2" : "ri-grid-fill"} style={{ fontSize: "24px" }}></i>
                                                    </button>
                                                )}


                                                <button
                                                    type="button"
                                                    className="btn btn-primary d-flex align-items-center"
                                                    onClick={isGridView ? handleFiltersToggleJob : handleFiltersToggle}
                                                >
                                                    <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                </button>

                                            </div>
                                        </div>



                                        {filtersEnabled && (
                                            <div className="card-body bJob bJob-dashed bJob-end-0 bJob-start-0">
                                                <div className="row g-3">
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                disabled={!filtersEnabled}
                                                                value={filterBy}
                                                                onChange={handleFilterByChange}
                                                            >
                                                                <option value="">Filter by</option>
                                                                <option value="job_number">ID</option>
                                                                <option value="ord_ID">Order Ref.</option>
                                                                <option value="fullname">Customer name</option>
                                                                <option value="materials_name">Material</option>
                                                            </select>

                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                id="idFilterStatus"
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterStatusChange}
                                                            >
                                                                <option value={0}>Filter status</option>
                                                                {statusQuot.map((status) => (
                                                                    <option key={status.est_ID} value={status.est_ID}>{status.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <CustomDateRangePicker onDateChange={handleDateChange} />
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="search-box">
                                                            <input
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder="Search for tasks or something..."
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterValueChange}
                                                            />
                                                            <i className="ri-search-line search-icon"></i>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        )}

                                        {filtersEnabledJob && (
                                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                                <div className="row g-3">
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                disabled={!filtersEnabledJob}
                                                                value={filterByJob}
                                                                onChange={handleFilterByChangeJob}
                                                            >
                                                                <option value="">Filter by</option>
                                                                <option value="materials_name">Alloy Type</option>
                                                                <option value="fullname">Customer</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                    <div className="col-4">
                                                        <CustomDateRangePicker onDateChange={handleDateChangeJob} />
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="search-box">
                                                            <input
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder="Search for tasks or something..."
                                                                disabled={!filtersEnabledJob}
                                                                onChange={handleFilterValueChangeJob}
                                                            />
                                                            <i className="ri-search-line search-icon"></i>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        )}

                                        {isGridView ? (
                                            <div className="card-body" style={{ padding: "0.25rem" }}>
                                                <div className="row g-1">
                                                    {gridjobList.map((job, index) => (
                                                        <div
                                                            key={index}
                                                            className={`selectable-card ${selectedJobs.includes(job.job_ID) ? 'selected' : ''} 
          ${cardSize === "vs" ? "col-6 col-sm-4 col-md-3 col-lg-1" :
                                                                    cardSize === "sm" ? "col-6 col-sm-4 col-md-3 col-lg-2" :
                                                                        cardSize === "md" ? "col-6 col-sm-4 col-md-3 col-lg-3" :
                                                                            "col-12 col-sm-6 col-md-4 col-lg-3"}`}
                                                            data-job-id={job.job_ID}
                                                            data-object={JSON.stringify(job)}
                                                            style={{ marginBottom: "4px" }}
                                                        >
                                                            <div
                                                                className="card shadow-sm border-0 rounded-3"
                                                                style={{
                                                                    transition: 'all 0.3s ease-in-out',
                                                                    fontSize: cardSize === "vs" ? '0.65rem' :
                                                                        cardSize === "sm" ? '0.75rem' :
                                                                            cardSize === "md" ? '0.875rem' : '1rem',
                                                                    margin: "0", padding: "0.25rem"
                                                                }}
                                                            >

                                                                <div className="d-flex justify-content-between align-items-center px-2 py-1 border-bottom">
                                                                    <span className="fw-bold text-primary">{job.job_ID}</span>
                                                                    {cardSize !== "vs" && <h6 className="mb-0">{job.fullname}</h6>}
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={selectedJobs.includes(String(job.job_ID))}
                                                                        onChange={() => handleCheckboxChange(job)}
                                                                    />
                                                                </div>


                                                                <div
                                                                    className="card-body d-flex p-1"
                                                                    style={{
                                                                        minHeight: cardSize === "vs" ? '8vh' :
                                                                            cardSize === "sm" ? '12vh' : '22vh',
                                                                        maxHeight: cardSize === "vs" ? '10vh' :
                                                                            cardSize === "sm" ? '12vh' : '22vh',
                                                                    }}
                                                                >
                                                                    <div className="me-2">
                                                                        <div style={{
                                                                            height: cardSize === "vs" ? "45px" :
                                                                                cardSize === "sm" ? "60px" : "15vh",
                                                                            width: cardSize === "vs" ? "45px" :
                                                                                cardSize === "sm" ? "60px" : "15vh"
                                                                        }}>
                                                                            {job?.files_path_file && getFileExtension(job.files_path_file) === "stl" ? (
                                                                                <SimpleSTLViewer url={`${server_backend}/${job.files_path_file}`} currentColor={job?.materials_color} />
                                                                            ) : job?.files_path_file ? (
                                                                                <img
                                                                                    src={`${server_backend}/${job.files_path_file}`}
                                                                                    alt="Selected File"
                                                                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                                                />
                                                                            ) : null}
                                                                        </div>
                                                                    </div>

                                                                    <div className="flex-grow-1 overflow-hidden">
                                                                        <p className="card-text mb-1">

                                                                            {cardSize !== "vs" && (
                                                                                <>
                                                                                    <strong>Alloy:</strong> {job.materials_name}<br />
                                                                                    <strong>Qty:</strong> {job.qty}<br />
                                                                                    <strong>Group:</strong> <Link>{job.colle_id === 0 ? 'No group' : job.collective_name}</Link><br />
                                                                                    <strong>Created:</strong> {vAdminformat.FormatDate(job.date_created)}
                                                                                </>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                {cardSize === "vs" && (
                                                                    <p style={{ marginBlock: "0" }}>
                                                                        <>
                                                                            <strong>{vAdminformat.truncateText(job.materials_name, 17)}</strong><br />
                                                                            <strong>{job.qty}</strong><br />
                                                                            <Link>{job.colle_id === 0 ? 'No group' : job.collective_name}</Link><br />
                                                                            {vAdminformat.FormatDate(job.date_created)}
                                                                        </>
                                                                    </p>
                                                                )}

                                                                <div className="card-footer d-flex align-items-center p-1" style={{ gap: "6px" }}>
                                                                    <div className="col-12">
                                                                        <div className="row gx-1 gy-1">
                                                                            <div className={`${cardSize === "vs" || cardSize === "sm" ? 'col-4' : 'col-2'}`}>
                                                                                <button
                                                                                    className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                                                                    style={{
                                                                                        height: "29px",
                                                                                        width: "4vh",
                                                                                        padding: "0.25rem"
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        setCurrentJob(job.job_ID);
                                                                                        showViewJob();
                                                                                    }}
                                                                                >
                                                                                    <i className="ri-eye-line fs-6"></i>
                                                                                </button>
                                                                            </div>
                                                                            <div className={`${cardSize === "vs" || cardSize === "sm" ? 'col-8' : 'col-10'}`}>
                                                                                <div className="border p-1 flex-grow-1" style={{ minHeight: "4vh", maxHeight: "4vh", overflow: "auto" }}>
                                                                                    <p className="mb-0" style={{ fontSize: cardSize === "vs" ? "0.6rem" : undefined }}>
                                                                                        <strong>{job.comment}</strong>
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {cardSize !== "vs" && (
                                                                            <p className="mb-1">
                                                                                <strong>Estimated Date:</strong> {vAdminformat.FormatDateSmall(job.date_estimated)}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                                <Selecto
                                                    container=".col-lg-12"
                                                    ref={selectoRef}
                                                    selectableTargets={[".selectable-card"]}
                                                    hitRate={0}
                                                    selectByClick={true}
                                                    selectFromInside={true}
                                                    toggleContinueSelect={["shift"]}
                                                    scrollOptions={{
                                                        container: () => document.querySelector(".col-lg-12"),
                                                        threshold: 30,
                                                        throttleTime: 10,
                                                        getScrollPosition: (e) => [e.container.scrollLeft, e.container.scrollTop],
                                                    }}
                                                    onSelect={(e) => {
                                                        if (e.inputEvent.target.tagName === "INPUT") return;

                                                        const selectedElements = e.selected || [];

                                                        const selectedIDs = selectedElements.map(el => el.getAttribute("data-job-id"));

                                                        const selectedObjects = selectedElements.map(el => {
                                                            const raw = el.getAttribute("data-object");
                                                            try {
                                                                return JSON.parse(raw);
                                                            } catch (error) {

                                                                return null;
                                                            }
                                                        }).filter(obj => obj !== null);

                                                        setSelectedJobs(selectedIDs.length === 1 ? [selectedIDs[0]] : selectedIDs);
                                                        setTemporalJobSelected(selectedObjects);
                                                    }}

                                                    onSelectEnd={handleDeselect}
                                                />
                                            </div>

                                        ) : (

                                            <div className="card-body">
                                                <div
                                                    className="table-responsive table-card mb-4"
                                                    style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                                >
                                                    <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                        <thead className="table-light text-muted">
                                                            <tr>
                                                                <th className="th-hover" onClick={() => handleColumnClick("job_number")}>ID</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("job_ID")}>Order Ref.</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("item_customer")}>Item & Customer</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("status")}>Group</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("status")}>Qty</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("materials_name")}>Material</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("date_estimated")}>Est. Completion</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="list form-check-all">
                                                            {currentItems.map((Jobs_L) => (
                                                                <tr key={Jobs_L.job_number}>
                                                                    <td className="id">
                                                                        <Link className="fw-medium link-primary" onClick={() => {
                                                                            setCurrentJob(Jobs_L.job_ID);
                                                                            showViewJob();
                                                                        }}>
                                                                            {Jobs_L.job_number}
                                                                        </Link>
                                                                    </td>
                                                                    <td>{Jobs_L.ord_ID}</td>
                                                                    <td>
                                                                        <h6>{Jobs_L.fullname}</h6>
                                                                        <span className={`badge ${Jobs_L.isMould ? 'bg-primary' : 'bg-secondary'}`} style={{ minWidth: "68px", maxWidth: "68px" }}>
                                                                            {Jobs_L.isMould ? 'Mould' : 'Job'}
                                                                        </span>
                                                                        <p
                                                                            className="text-muted mb-0"
                                                                            data-bs-toggle="tooltip"
                                                                            data-bs-placement="top"
                                                                            title={Jobs_L.file_name}>File: {vAdminformat.truncateText(Jobs_L.file_name, 30)}</p>
                                                                        <p
                                                                            className="text-muted mb-0"
                                                                            data-bs-toggle="tooltip"
                                                                            data-bs-placement="top"
                                                                            title={Jobs_L.comment}>Description: {vAdminformat.truncateText(Jobs_L.comment, 50)}</p>

                                                                        <p
                                                                            className="text-muted mb-0"
                                                                            data-bs-toggle="tooltip"
                                                                            data-bs-placement="top"
                                                                            title={Jobs_L.file_name}>Status: {Jobs_L.status_name}</p>

                                                                    </td>
                                                                    <td className="status" style={{ minWidth: "22vh" }}>
                                                                        <div className="input-group">
                                                                            <label className="input-group-text" htmlFor={`collectiveSelect-${Jobs_L.job_ID}`}>
                                                                                <i className="ri-group-line"></i>
                                                                            </label>
                                                                            {Jobs_L.colle_id === 0 ? (
                                                                                <select
                                                                                    id={`collectiveSelect-${Jobs_L.job_ID}`}
                                                                                    className="form-select form-select-sm"
                                                                                    aria-label="Select Collective Group"
                                                                                    name="optjc_id"
                                                                                    value={Jobs_L.colle_id || ''}
                                                                                    onChange={(e) => AsignCollectiveGroup(Jobs_L.job_ID, e.target.value)}
                                                                                >
                                                                                    <option value={0}>No Group</option>
                                                                                    {collectiveList.map(uniqueOption => (
                                                                                        <option
                                                                                            key={uniqueOption.colle_id}
                                                                                            value={uniqueOption.colle_id}
                                                                                        >
                                                                                            {uniqueOption.name}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            ) : (
                                                                                <select
                                                                                    id={`collectiveSelect-${Jobs_L.job_ID}`}
                                                                                    className="form-select form-select-sm"
                                                                                    aria-label="Select Collective Group"
                                                                                    name="optjc_id"
                                                                                    disabled
                                                                                    value={Jobs_L.colle_id || ''}
                                                                                >
                                                                                    <option value={0}>No Group</option>
                                                                                    {collectiveList.map(uniqueOption => (
                                                                                        <option
                                                                                            key={uniqueOption.colle_id}
                                                                                            value={uniqueOption.colle_id}
                                                                                        >
                                                                                            {uniqueOption.name}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            )
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        {Jobs_L.qty}
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-muted mb-0">
                                                                            <span
                                                                                style={{
                                                                                    display: "inline-block",
                                                                                    width: "12px",
                                                                                    height: "12px",
                                                                                    backgroundColor: Jobs_L.materials_color || "rgb(226, 226, 226)",
                                                                                    borderRadius: "50%",
                                                                                    marginRight: "5px",
                                                                                }}
                                                                            ></span>
                                                                            {Jobs_L.materials_name}</p>
                                                                    </td>
                                                                    <td className="date">{vAdminformat.FormatDate(Jobs_L.date_estimated)}</td>
                                                                    <td className="due_date">
                                                                        <ul className="list-inline hstack gap-2 mb-0 fs-5">
                                                                            <li className="list-inline-item">
                                                                                <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                                    setCurrentJob(Jobs_L.job_ID);
                                                                                    showViewJob();
                                                                                }} data-toggle="tooltip" data-placement="top" title="View">
                                                                                    <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                                </Link>
                                                                            </li>

                                                                            <li className="list-inline-item">
                                                                                <button type="button" className="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Print" onClick={() => {

                                                                                    printSingleSelected([Jobs_L])
                                                                                }}>
                                                                                    <i className="ri-printer-line"></i>
                                                                                </button>
                                                                            </li>

                                                                            <li className="list-inline-item edit">
                                                                                {isRepriting ? (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-secondary"
                                                                                        data-bs-toggle="tooltip"
                                                                                        data-bs-placement="top"
                                                                                        title="Print"
                                                                                        onClick={() => {
                                                                                            setCurrentJob(Jobs_L.job_ID);
                                                                                            showAddCommentModal()
                                                                                        }}
                                                                                    >
                                                                                        <i className=" ri-reply-line"></i>
                                                                                    </button>
                                                                                )
                                                                                    : (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-success"
                                                                                            data-bs-toggle="tooltip"
                                                                                            data-bs-placement="top"
                                                                                            title="Print"
                                                                                            onClick={() => {
                                                                                                setCurrentJob(Jobs_L.job_ID);
                                                                                                showAddCommentModal()
                                                                                            }}
                                                                                        >
                                                                                            <i className="ri-printer-line"></i>
                                                                                        </button>
                                                                                    )}

                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="row justify-content-between align-items-center">
                                                    <div className="col-auto me-3">
                                                        <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, JobList.length)} of {JobList.length} entries</p>
                                                    </div>
                                                    <div className="col-auto">
                                                        <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                            </li>
                                                            {Array.from({ length: totalPages }, (_, index) => (
                                                                <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                                    <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                                </li>
                                                            ))}
                                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="row g-0 text-center text-sm-start">
                                                    <div className="col-sm-6">
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    )

                )
            )}

            {isComment && (
                <AddLiveJobComment JobID={currentJob} onClose={CloseAddCommentModal} getJobs={getJobs} isBegin={false} />
            )}

            {showPrintableDiv && (
                <div ref={componentRef} id="printable-area" className="mt-2 p-2">
                    {currentJobToPrint && currentJobToPrint.length > 0 ? (
                        currentJobToPrint.map((job, index) => (
                            <div
                                key={index}
                                className="single-job-print-page"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    margin: "0 auto 20px auto",
                                    padding: "6px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    boxSizing: "border-box",
                                    pageBreakAfter: "always",
                                    fontSize: "10px",
                                }}
                            >
                                <div className="row">
                                    <div className="col-12 text-start">
                                        <strong>{job.fullname}</strong>
                                    </div>
                                </div>

                                <div className="row mb-1">
                                    <div className="col-12 text-start">
                                        <a
                                            href="#"
                                            style={{
                                                fontWeight: "bold",
                                                color: "#007bff",
                                                fontSize: "10px",
                                            }}
                                        >
                                            {job.job_number}
                                        </a>
                                    </div>
                                </div>


                                <div className="row d-flex align-items-stretch">
                                    <div className="col-6 d-flex flex-column align-items-center">
                                        <span
                                            className="badge bg-light text-dark d-flex align-items-center gap-1 border w-100 justify-content-center"
                                            style={{ fontSize: "0.7rem" }}
                                            title={job.isMould ? "Mould" : "Job (STL)"}
                                        >
                                            <i
                                                className={`ri ${job.isMould ? "ri-coin-line" : "bx bx-cube"
                                                    } fs-6`}
                                            ></i>
                                            {job.isMould ? "Mould" : "STL"}
                                        </span>
                                        <div
                                            className="d-flex justify-content-center align-items-center border mt-1"
                                            style={{
                                                width: "110px",
                                                height: "110px",
                                            }}
                                        >
                                            {job.image ? (
                                                <img
                                                    src={job.image}
                                                    alt="STL"
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain",
                                                    }}
                                                />
                                            ) : (
                                                <p className="m-0" style={{ fontSize: "8px" }}>
                                                    Loading Image...
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-6 d-flex flex-column justify-content-center align-items-center">
                                        <div className="text-center mb-1" style={{ fontSize: "9px" }}>
                                            Group ID
                                        </div>
                                        <div
                                            className="d-flex justify-content-center align-items-center border mt-2"
                                            style={{
                                                width: "110px",
                                                height: "110px",
                                            }}
                                        >
                                            {job?.colle_id ? (
                                                <QRCode
                                                    size={140}
                                                    value={`${server_frontend}/jobs/collective/qr-group?group=${job.colle_id}`}
                                                    viewBox="0 0 256 256"
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        fontSize: "8px",
                                                        color: "#666",
                                                        textAlign: "center",
                                                        padding: "3px",
                                                    }}
                                                >
                                                    No assigned<br />group
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-12 mt-2">
                                    <div className="row d-flex align-items-center">
                                        <div className="col-8">
                                            <div
                                                className="text-start"
                                                style={{
                                                    fontSize: "10px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "4px",
                                                    minHeight: "70px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "space-between",
                                                    height: "100%",
                                                }}
                                            >
                                                <div>
                                                    <strong>{job.materials_name}</strong>
                                                </div>
                                                <div>Qty: {job.quantity || 1}</div>
                                            </div>
                                        </div>

                                        <div className="col-4 d-flex justify-content-center align-items-center">
                                            {job?.barcode && (
                                                <div className="text-center">
                                                    <div style={{ fontSize: "9px", marginBottom: "2px" }}>Job ID</div>
                                                    <QRCode
                                                        size={60}
                                                        value={`${server_frontend}/jobs/qr-single-job?qr=${job.barcode}`}
                                                        viewBox="0 0 256 256"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        ))
                    ) : (
                        <div
                            className="single-job-print-page"
                            style={{
                                width: "265px",
                                height: "265px",
                                margin: "0 auto 20px auto",
                                padding: "6px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                boxSizing: "border-box",
                                pageBreakAfter: "always",
                                fontSize: "10px",
                            }}
                        ></div>
                    )}
                </div>
            )}

            <div className={`modal fade ${addCollectiveModal ? 'show' : ''}`}
                style={{ display: addCollectiveModal ? 'block' : 'none', backgroundColor: "#0000007a" }}
                tabIndex="-1">

                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "40%" }}>
                    <div className="modal-content shadow-lg border-0 rounded-3">
                        <div className="modal-header bg-primary text-white" style={{ minHeight: "50px" }}>
                            <button type="button" className="btn-close" onClick={closeModalCollective} aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <i className="mdi mdi-human-dolly text-primary fs-1 mb-3"></i>
                            <h5 className="fw-bold text-primary">Choose a group</h5>
                            <select id="groupSelect" className="form-select shadow-sm" onChange={handleGroupChange} value={selectedGroup}>
                                <option value="">Select a group...</option>
                                {collectiveList.map(group => (
                                    <option key={group.colle_id} value={group.colle_id}>{group.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <button type="button" className="btn btn-secondary" onClick={closeModalCollective}>Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={addJobToGroup}>Confirm</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default WaxMouldFolder;
